import { getUsersListByIds } from "@/services";
import { useMemoizedFn, useSetState } from "ahooks";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import { Else, If, Then } from "react-if";
import styles from "./index.module.less";

import HBSwiper from "@/components/HBSwiper";
import UserCard from "@/components/UserCard";

export default function FollowingCertifyList({ ids }) {
  const router = useRouter();
  const { urlname } = router.query;

  const [query, setQuery] = useSetState({
    max: 0,
    urlname: "",
  });
  const [hasMore, setHasMore] = useState(true);
  const [count, setCount] = useState(0);
  const [dataSource, setDataSource] = useState([]);
  const [cardType, setCardType] = useState("card");

  const init = useMemoizedFn(async () => {
    if (!ids || ids.length == 0) {
      return;
    }
    const result = await getUsersListByIds(ids);

    if (result?.user?.user_following_count) {
      setCount(result?.user.user_following_count);
    }

    const users = result?.users || [];
    if (users.length <= 0) {
      setHasMore(false);
    }
    setDataSource(users);
  });

  useEffect(() => {
    init();
  }, [ids, init]);

  const onLoadMore = useCallback(() => {
    if (dataSource.length > 0) {
      const last = dataSource[dataSource.length - 1];
      setQuery({
        max: last.seq || last.user_id,
      });
    }
  }, [dataSource, setQuery]);

  return (
    <div className={styles.user}>
      <div className={styles.more}></div>
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          <HBSwiper type="page">
            {dataSource.map((item, index) => (
              <UserCard
                key={index}
                record={item}
                style={
                  index + 1 !== dataSource.length
                    ? { marginRight: "24px", marginTop: "0" }
                    : { marginTop: "0" }
                }
              />
            ))}
          </HBSwiper>
        </Then>
        <Else>
          <div className={styles.empty}>暂无数据</div>
        </Else>
      </If>
    </div>
  );
}
